module.exports = __webpack_public_path__ + "img/product-image-placeholder.2229c10d.jpg";